import { BaseModel } from '../base.model';

export enum ExternalPersonKeys {
  description = 'description',
}

export class ExternalPerson extends BaseModel {
  [ExternalPersonKeys.description]: string = null;
}
